import { Role } from "../../../helpers/role";
export const DealerRetailerMenu = [
  {
    title: "Home",
    icon: "mdi-view-dashboard",
    to: "",
    code: "dashboard",
    role: [Role.DealerRetailer],
  },

  {
    title: "Sales Reports",
    icon: "mdi-chart-line",
    role: [Role.DealerRetailer],
    code: "sales-reports",
    submenu: [
      {
        title: "Retailer / Dealer",
        icon: "",
        to: "retailer-dealer",
        code: "retailer-dealer",
        role: [Role.DealerRetailer],
      },
      {
        title: "Per Area",
        icon: "",
        to: "per-area",
        code: "per-area",
        role: [Role.DealerRetailer],
      },

      {
        title: "Online",
        icon: "",
        to: "online",
        code: "online",
        role: [Role.DealerRetailer],
      },
    ],
  },

  {
    title: "Dealer",
    icon: "mdi-clipboard-check",
    code: "main-dealer",
    role: [Role.DealerRetailer],
    submenu: [
      {
        title: "List",
        icon: "",
        to: "dealer-list",
        code: "dealer-list",
        role: [Role.DealerRetailer],
      },
      {
        title: "Top-up Report",
        icon: "",
        to: "top-up-report",
        code: "top-up-report",
        role: [Role.DealerRetailer],
      },
    ],
  },

  {
    title: "Approver",
    icon: "mdi-thumb-up",
    code: "approver",
    role: [Role.DealerRetailer],
    submenu: [
      {
        title: "Pending Dealer Request",
        icon: "",
        to: "pending-dealer-request",
        code: "pending-dealer-request",
        badge: {
          status: true,
          value: "pending-dealer-request",
        },
        role: [Role.DealerRetailer],
      },

      {
        title: "Pending Top-up Request",
        icon: "",
        to: "pending-topup-request",
        code: "pending-topup-request",
        badge: {
          status: true,
          value: "pending-topup-request",
        },
        role: [Role.DealerRetailer],
      },

      {
        title: "Approved Top-up Request",
        icon: "",
        to: "approved-topup-request",
        code: "approved-topup-request",
        role: [Role.DealerRetailer],
      },
    ],
  },

  {
    title: "Verifier",
    icon: "mdi-account-tie",
    code: "approver",
    role: [Role.DealerRetailer],
    submenu: [
      {
        title: "Pending Top-up Request",
        icon: "",
        to: "verifier/pending-dealer-request",
        code: "ver-pending-dealer-request",
        badge: {
          status: true,
          value: "pending-dealer-request",
        },
        role: [Role.DealerRetailer],
      },

      {
        title: "Approved Top-up Request",
        icon: "",
        to: "verifier/approved-topup-request",
        code: "ver-approved-topup-request",
        role: [Role.DealerRetailer],
      },
    ],
  },
];
